const tagFamilyConstants = Object.freeze({
  COST_CENTER: 'cost_center',
  EXPENSE: 'expense',
  VENDORS: 'vendors',
  TEAM: 'team',
  PROJECT: 'project',
  LOCATION: 'location',
});

export {
  tagFamilyConstants,
};
